module.exports = __webpack_public_path__ + "img/avatar_default.dc9bbfda.png";